module.exports = __webpack_public_path__ + "img/BRKb.1eedd34b.png";